import {
    createStyles,
    ThemeIcon,
    Progress,
    Text,
    Group,
    Paper,
    rem,
    Image,
    Space,
    Tooltip,
    CopyButton,
    ActionIcon, NavLink, Center, Button, Alert, Modal
} from '@mantine/core';
import {IconCheck, IconCopy, IconInfoCircle, IconLetterG, IconSwimming, IconAlertCircle} from '@tabler/icons-react';
import {AccountModel} from "../models/AccountModels";
import React, {useEffect, useState} from "react";
import moment, {Duration} from "moment";
import {DepositModel} from "../models/DepositModels";
import {DepositSetAsTimeoutAsync} from '../services/PaymentService';
import QRCode from "react-qr-code";

const ICON_SIZE = rem(60);
const useStyles = createStyles((theme) => ({
    card: {
        position: 'relative',
        overflow: 'visible',
        padding: theme.spacing.xl,
        paddingTop: `calc(${theme.spacing.xl} * 1.5 + ${ICON_SIZE} / 3)`,
    },

    icon: {
        position: 'absolute',
        top: `calc(-${ICON_SIZE} / 3)`,
        left: `calc(50% - ${ICON_SIZE} / 2)`,
    },

    title: {
        fontFamily: `Greycliff CF, ${theme.fontFamily}`,
        lineHeight: 1,
    },
}));


interface Props {
    account: AccountModel
    deposit: DepositModel
    handleSetAsTimeoutAsync: () => void
}

export const Pay = ({account, deposit, handleSetAsTimeoutAsync}: Props) => {


    const {classes} = useStyles();
    const [durationLeft, setDurationLeft] = useState<Duration>(moment.duration);
    const [paparaPaymentUrl, setPaparaPaymentUrl] = useState<string>("");
    const [showWarningModal, setShowWarningModal] = useState<boolean>(true);

    const timer = () => {
        let dur = moment.duration((1000 * moment().subtract(5, 'minutes').diff(deposit.createdDate, 'seconds')))
        if (dur.minutes() <= 0 && dur.seconds() <= 0)
            setDurationLeft(dur)
        else {
            // setDurationLeft(moment.duration(0))
        }
    }
    const renderCopyButtonAccNumber = () => {
        return <CopyButton value={deposit.receiverAccNumber?.length>5 && deposit.receiverAccName.length>3 ?deposit.receiverAccNumber: account?.accountNumber} timeout={2000}>
            {({copied, copy}) => (
                <Tooltip label={copied ? 'Kopyalandı' : 'Kopyala'} withArrow position="right">
                    <ActionIcon color={copied ? 'teal' : 'gray'} onClick={(e) => {
                        copy()
                        // navigator.clipboard.writeText(account?.accountNumber)
                    }}>
                        {copied ? <IconCheck size="1rem"/> : <IconCopy size="1rem"/>}
                    </ActionIcon>
                </Tooltip>
            )}
        </CopyButton>
    }
    const renderCopyButtonAccName = () => {
        return <CopyButton value={deposit.receiverAccNumber?.length>5 && deposit.receiverAccName.length>3 ?deposit.receiverAccName: account?.name} timeout={2000}>
            {({copied, copy}) => (
                <Tooltip label={copied ? 'Kopyalandı' : 'Kopyala'} withArrow position="right">
                    <ActionIcon color={copied ? 'teal' : 'gray'} onClick={(e) => {
                        copy()
                        // navigator.clipboard.writeText(account?.accountNumber)
                    }}>
                        {copied ? <IconCheck size="1rem"/> : <IconCopy size="1rem"/>}
                    </ActionIcon>
                </Tooltip>
            )}
        </CopyButton>
    }
    useEffect(() => {

        setPaparaPaymentUrl(`https://www.papara.com/personal/qr?currency=0&accountNumber=${account?.accountNumber}&amount=${deposit.amount}`)
    }, [deposit])
    useEffect(() => {
        timer()
        const intervalId = setInterval(() => {
            let dur = moment.duration((1000 * moment().subtract(5, 'minutes').diff(deposit.createdDate, 'seconds')))
            if (dur.minutes() <= 0 && dur.seconds() <= 0)
                setDurationLeft(dur)
            else {
                setDurationLeft(moment.duration(0))
                // handleSetAsTimeoutAsync()
            }
        }, 1000)
        return () => {
            clearInterval(intervalId);
        };
    }, [])
    return (
        <>
            <Modal
                opened={showWarningModal}
                onClose={() => setShowWarningModal(false)}
                title={
                    <Group spacing="xs">
                        <IconAlertCircle size={20} color="red" />
                        <Text fw={700} c="red">Önemli Uyarı</Text>
                    </Group>
                }
                centered
                overlayProps={{ opacity: 0.75, blur: 3 }}
                closeOnClickOutside={false}
                closeOnEscape={false}
                withCloseButton={false}
            >
                <Alert  title="" color="red" variant="outline" mb="md">
                    <Text size="sm" fw={500}>
                        {/*Hesap bilgileri güncellenmiştir. Yatırımınızın anında yansıması için lütfen <Text component="span" fw={1000}>bu ekranda gördüğünüz hesap bilgilerini</Text> kullandığınıza emin olunuz!*/}
                        Talep tutarında yatırım yapınız. Limit Altı yatırımlarınız onay almayacak ve iade edilmeyecektir.
                    </Text>
                </Alert>
                <Group position="center">
                    <Button onClick={() => setShowWarningModal(false)} color="red" size="md">
                        Anladım
                    </Button>
                </Group>
            </Modal>
            <Paper radius="md" className={classes.card} mt={`calc(${ICON_SIZE} / 6)`}>
                <ThemeIcon style={{backgroundColor: "black"}} className={classes.icon} size={ICON_SIZE} radius={ICON_SIZE}>
                    <Image radius={100} src={process.env.REACT_APP_API_URL + account?.bank?.icon?.path} alt={""}/>
                </ThemeIcon>

            <Group position={'center'}>

                {/*{deposit.paymentWayId === 2 ||deposit.paymentWayId == 1 ||  deposit.paymentWayId===4 ||(deposit.account?.accountGroupId===7) || deposit.account?.accountGroupId===8 || deposit.account?.accountGroupId===9 || deposit.account?.accountGroupId===12 ? (*/}
                {deposit.paymentWayId != 1 ? (
                    <>
                        <Group>
                            <Center>

                                <Text ml={20} align={'center'} fw={700} className={classes.title}>
                                {deposit.receiverAccNumber?.length>5 && deposit.receiverAccName.length>3 ?deposit.receiverAccNumber: account?.accountNumber} 
                                </Text>
                                {renderCopyButtonAccNumber()}
                            </Center>
                        </Group>
                    </>
                ) : (
                    <>
                        <Group>
                            {paparaPaymentUrl != "" && account.accountGroupId !== 4 ? (
                                <div style={{padding: 15, margin: 10, backgroundColor: 'white', borderRadius: 15}}>


                                    <QRCode size={120}
                                            value={decodeURI(paparaPaymentUrl)}/>
                                </div>
                            ) : <></>}

                        </Group>
                    </>
                )}
            </Group>
            <Center>
                <Text c="dimmed" ta="center" fz="sm">
                    {/*{account?.name}*/}
                    { deposit.receiverAccNumber?.length>5 && deposit.receiverAccName.length>3 ?deposit.receiverAccName: account?.name}
                </Text>
                {renderCopyButtonAccName()}
            </Center>
            {deposit.paymentWayId === 1 && deposit.account?.accountGroupId!==8 ? (
                <>
                    <Center mt={15}>
                        <Text>Hesap Numarası</Text>
                    </Center>
                    <Center>

                        <Text align={'center'} fw={700} className={classes.title}>
                            {(deposit.paymentWayId===1||deposit.account?.affiliateId===100071)&& deposit.receiverAccNumber?.length>5 && deposit.receiverAccName.length>3 ?deposit.receiverAccNumber: account?.accountNumber}
                        </Text>
                        {renderCopyButtonAccNumber()}
                    </Center>

                    <Space h={15}></Space>
                    {account.accountGroupId !== 4 ?? (
                        <Center>
                            <Button style={{backgroundColor: '#901f80'}}>
                                <a target="_blank"
                                   rel="noreferrer" href={paparaPaymentUrl}>
                                    <Image maw={150} radius="md"
                                           src="data:image/png;base64,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"/>
                                </a>
                            </Button>
                        </Center>
                    )}
                </>
            ) : <></>}
            <Space h="md"/>
            <Alert variant="light" color="red" radius="lg"
                   title="Dikkat" icon={<IconInfoCircle/>}>
                Açıklama kısmını boş bırakınız. Herhangi bir açıklama eklemeniz durumunda yatırımınız onay
                almayacak ve iade edilmeyecektir.
            </Alert>
            <Space h="md"/>
            <Alert variant="light" color="blue" radius="lg"
                   title="Dikkat" icon={<IconInfoCircle/>}>
                Transfer işleminden sonra "Ödemeyi Gerçekleştirdim" butonunu seçmeyi
                unutmayınız. Aksi takdirde yatırımınız onay almayacaktır.
            </Alert>
            <Space h="md"/>
            <Space h="md"/>
            <Group position="apart" mt="xs">
                <Text fz="sm" color="dimmed">
                    Kalan Süre
                </Text>
                <Text fz="sm" color="primary">

                    {(Math.abs(durationLeft.minutes()).toString().length === 1 ? '0' : '') + `${Math.abs(durationLeft?.minutes())}:${(Math.abs(durationLeft.seconds()).toString().length === 1 ? '0' : '')}${Math.abs(durationLeft?.seconds())}`}
                </Text>
            </Group>
            <Progress
                animate size={"xl"} value={100 - (Math.abs(durationLeft.asSeconds()) / 3)} mt={5}/>
            <Space h="md"/>
            <Text align={'center'} fz="lg">{account?.bank?.name}</Text>

        </Paper>
        </>
    )
        ;
}